export default "__VITE_ASSET__aa461a3a__"